const ru = {
  action: {
    subscribe: 'Подключить',
    rule: 'Полные правила',
    close: 'Хорошо',
    wantTheSame: 'Хочу так же'
  },
  town: {
    almaty: 'Алматы',
    astana: 'Астана',
    karaganda: 'Караганда',
    atyrau: 'Атырау',
    uralsk : 'Уральск',
    kordaiDistrict: 'Кордайский район'
  },
  menu: {
    logo: 'Национальная<br />лотерея',
    participate: 'Участвовать в лотерее',
    prizes: 'Призы',
    rules: 'Правила лотереи',
    feedback: 'Обратная связь',
    hotLineDesktop: 'Горячая линия <a href="tel:88000809351" target="_blank" rel="noreferrer">8-800-080-9351</a>',
    hotLineMobile: 'Для получения подробной информации или решения возникшего вопроса позвонитена бесплатный номер<br/> <a href="tel:88000809351" target="_blank" rel="noreferrer">8-800-080-9351</a>'
  },
  label: {
    logo: 'Национальная лотерея',
    win: 'выигрышей'
  },
  common: {
    title: 'Национальная лотерея'
  },
  promo: {
    title: 'Выиграйте 1 000 000₸ в лотерее по подписке',
    desc: [
      'Оформите подписку за 100 тенге в сутки и выигрывайте денежные призы каждый день!',
      'Моментальная лотерея для абонентов<br/><strong>Tele2/Altel</strong>, <strong>Kcell/activ</strong> и <strong>Beeline</strong>'
    ]
  },
  about: {
    title: [
      'Моментальная лотерея  «Твоя удача» для абонентов Tele2/Altel!',
      'Моментальная лотерея «OGO Удача» для абонентов Kcell/Activ!',
      'Моментальная лотерея «Удача» для абонентов Beeline!'
    ],
    list: [
      'Суперприз 1 000 000 ₸<br/>Если выиграете, мы свяжемся с Вами сами для передачи выигрыша',
      'Миллионы денежных призов c мгновенным зачислением на абонентский счет',
      'Стоимость каждого билета всего 100 ₸, билет приходит в SMS каждый день',
      'Билет разыгрывается моментально, вы сразу узнаете результат розыгрыша'
    ]
  },
  prizeFond: {
    title: [
      'Призовой фонд лотереи «Твоя удача»',
      'Призовой фонд лотереи «OGO Удача»',
      'Призовой фонд лотереи «Удача»'
    ],
    label: {
      superPrize: 'Супер приз',
      superPrizeCount: '3 Супер-приза'
    }
  },
  winners: {
    title: 'Наши победители'
  },
  modal: {
    subscribe: {
      title: 'Выиграйте миллион',
      desc: [
        'Ваш запрос принят. Подробности о подписке на лотерею, лотерейные билеты и информацию о выигрыше ожидайте по SMS.'
      ]
    },
    error: {
      title: 'Ошибка подключения',
      desc: 'При подключении подписки на лотерею произошла ошибка. Пожалуйста, попробуйте позже.',
      button: 'Закрыть'
    },
    info: {
      title: 'Участвуйте в лотерее',
      desc: [
        'Получайте лотерейные билеты в SMS каждый день и попробуйте выиграть миллион!',
        'Для участия в моментальной лотерее для абонентов Tele2/Altel, KCell/Activ и Beeline у вас должна быть оформлена подписка, стоимость 100 ₸/день.',
        '<b>Для активации подписки</b> наберите на мобильном телефоне USSD <a href="tel:*88#"><b>*88#</b></a>',
        '<b>Чтобы купить еще один или несколько билетов,</b> наберите <a href="tel:*88*N#"><b>*88*N#</b></a> где N количество билетов от 1 до 10. Например, чтобы купить 10 билетов, наберите <a href="tel:*88*10#"><b>*88*10#</b></a> Стоимость каждого купленного билета 100 ₸.',
        'Для получения подробной информации или решения возникшего вопроса позвоните на бесплатный номер <a href="tel: 88000809351"><b class="no-wrap">8-800-080-9351</b></a>'
      ]
    }
  },
  footer: {
    company: `${new Date().getFullYear()} ©  АО «Сәтті Жұлдыз»`,
    feedback: 'Обратная связь',
    terms: 'Пользовательское соглашение',
    socialHeader: 'СОЦИАЛЬНАЯ ОТВЕТСТВЕННОСТЬ:',
    socialDesc: '10% от операционного игрового дохода перечисляется на развитие отечественного спорта. 10% от операционного игрового дохода перечисляется в Общественный Фонд «Қазақстан Халқына».'
  }
};

export default ru;
